import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';

export const selectSeguridad = (state: AppState) => state.seguridad;
export const selectSeguridadUser = createSelector(selectSeguridad, (seguridad) => seguridad.user);
